import { render, staticRenderFns } from "./FailedEmailValidation.vue?vue&type=template&id=71424f42&scoped=true&"
import script from "./FailedEmailValidation.vue?vue&type=script&lang=js&"
export * from "./FailedEmailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71424f42",
  null
  
)

export default component.exports